<template>
  <div class="main-header">
    <div class="title-header">
      <img src="@/assets/agco-logo.svg">
    </div>
    <div class="logout">
      <h4><span><i class="icon-user"/>&nbsp;&nbsp;{{ profile.name }}</span></h4>
      <el-dropdown
        trigger="click"
        @command="clickOnDropDownItem">
        <span class="el-dropdown-link">
          <el-button>
            <i class="icon-more-vertical"/>
          </el-button>
        </span>
        <el-dropdown-menu
          slot="dropdown"
          style="padding: 0px">
          <el-dropdown-item command="onLogout">
            <span><i class="icon-log-out"/>Cerrar sesión</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import AuthService from '@/services/auth.service'
export default {
  name: 'AppHeader',
  computed: {
    profile () {
      return this.$store.getters['profile/me']
    }
  },
  methods: {
    clickOnDropDownItem (command) {
      if (command === 'onLogout') {
        AuthService.logout()
        this.$router.push('/')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .main-header {
    background-color: $light;
    font-size: 0;
    width: 100%;
    height: 100%;
    border: 1px solid#DDDDDD;
    display: flex;
    justify-content: space-between;
    position: relative;
    .title-header{
      display: flex;
      align-items:center;
      img{
        width: 120px;
        height: 80%;
        margin-left: 10px;
      }
    }
    .logout{
      border-left: 1px solid $border-primary;
      width: 200px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      h4 {
        @include font-lato(14px, bold);
        color: $header-list;
        margin-bottom: 10px;
        margin-left: 10px;
      }
      .el-dropdown{
        height: 100%;
        .el-button{
          height: 100%;
          border: none;
          border-radius: 0px;
          font-size: 18px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/app/app-header.vue